<template>

  <a
      @click.prevent="openFile()"
      href="#"
      :title="filename"
      class="text-decoration-none link-secondary me-3 d-inline-flex align-items-start label-truncated"
  >
    <small
        :class="(info.ico_class? info.ico_class: 'bi bi-question-square text-muted') +' me-1'"
    />

      {{filename}}

  </a>


  <!--
    <display-debug>
      <template #debugView>
        info: {{info}}
      </template>
    </display-g>


    -->


</template>
<script>

import axios from "axios";

export default {
  name: "fileAttachmentInfo",
  props: {
    "fileId": [Number],
    "filename": [String],
    "info": [Object],
  },
  components: {

  },
  emits: [
    //'update:modelValue',
  ],
  data() {
    return {
      file:{},
    }
  },
  methods: {
    async getDownloadFile(path, filename = null) {
      console.log('dev getDownloadFile', path);
      await axios({
        method: 'get',
        url: path,
        responseType: 'blob',
      }).then((response) => {
        //this.getDownloadFile(res.data.response.data.path);
        //console.log('dev fileAttachmentInfo openFile RES B', res.data.response.data.path);
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        //console.log('dev downloadu url', url)
        link.href = url;
        link.download = filename; // Název souboru
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }).catch((err) => {
        this.err = "openLink nenalezen, kontaktujte spravce"
      }).finally((f) => {

      })


    },

    async openFile(){
      const formData = new FormData();
      formData.append('id', this.fileId);

      axios.defaults.baseURL = this.getBaseRoot();
      await axios({
        method: 'get',
        url: this.getApiConfig('file.download.path') + '?id=' +this.fileId,
        withCredentials: true,
        headers: this.getRequestHeader(),
        data: formData,
        //responseType: 'blob',
      }).then((res) => {
        //console.log('dev fileAttachmentInfo openFile RES B', res.data.response.data);
        this.getDownloadFile(
            res.data.response.data.path,
            res.data.response.data.filename
        );
        //

      }).catch((err) => {
        this.err = "openLink nenalezen, kontaktujte spravce"
      }).finally((f) => {

      })

      //console.log('dev fileAttachmentInfo openFile', this.fileId, this.filename, this.info)
    }
  },
  computed: {

  },
  mounted() {

  },
  created() {

  },
  watch: {

  }
};
</script>
<style lang="scss" scoped>
.label-truncated {
  max-width: 100%;       // Tlačítko nepřekročí šířku rodiče
  display: inline-block; // Zajišťuje správné chování text-overflow
  overflow: hidden;      // Skryje přetékající text
  text-overflow: ellipsis; // Přidá tři tečky (...)
  white-space: nowrap;   // Zabrání zalomení textu do nového řádku

  //border: 1px solid lime;
}

</style>